 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"fbDataDeletionInstructions":"fbDataDeletionInstructions","homeMenuAdminArchive~homeMenuAdminPackages~userOrders":"homeMenuAdminArchive~homeMenuAdminPackages~userOrders","homeMenuAdminPackages":"homeMenuAdminPackages","homeMenuAdminArchive~settingsClient~settingsColors~settingsDelivery~settingsGiftCardActive~settingsI~16d883cc":"homeMenuAdminArchive~settingsClient~settingsColors~settingsDelivery~settingsGiftCardActive~settingsI~16d883cc","homeMenuAdminArchive":"homeMenuAdminArchive","userOrders":"userOrders","settingsClient~settingsDelivery~settingsGiftCardActive~settingsImageDatabase~settingsImageDatabaseCa~9ab29113":"settingsClient~settingsDelivery~settingsGiftCardActive~settingsImageDatabase~settingsImageDatabaseCa~9ab29113","settingsClient":"settingsClient","settingsDelivery":"settingsDelivery","settingsGiftCardActive~settingsPromoCodes":"settingsGiftCardActive~settingsPromoCodes","settingsGiftCardActive":"settingsGiftCardActive","settingsPromoCodes":"settingsPromoCodes","settingsImageDatabaseCategory":"settingsImageDatabaseCategory","settingsImageDatabase~settingsImageTemplate~settingsPhotoGift~userNewOrderBasic~userNewPhotoGiftOrde~6de9c91a":"settingsImageDatabase~settingsImageTemplate~settingsPhotoGift~userNewOrderBasic~userNewPhotoGiftOrde~6de9c91a","settingsImageDatabase~settingsImageTemplate~settingsPhotoGift~userNewOrderBasic~userNewPhotoGiftOrderDesign":"settingsImageDatabase~settingsImageTemplate~settingsPhotoGift~userNewOrderBasic~userNewPhotoGiftOrderDesign","settingsImageDatabase":"settingsImageDatabase","settingsImageTemplate":"settingsImageTemplate","settingsPhotoGift":"settingsPhotoGift","settingsImageDiscounts":"settingsImageDiscounts","settingsImageSize":"settingsImageSize","settingsPaperType":"settingsPaperType","settingsPhotoGiftCategory":"settingsPhotoGiftCategory","settingsPhotoGiftSuperCategory":"settingsPhotoGiftSuperCategory","settingsColors~userNewPhotoGiftOrderDesign":"settingsColors~userNewPhotoGiftOrderDesign","settingsColors":"settingsColors","userNewPhotoGiftOrderDesign":"userNewPhotoGiftOrderDesign","userNewOrderBasic~userNewPhotoGiftOrderFinalize":"userNewOrderBasic~userNewPhotoGiftOrderFinalize","userNewOrderBasic":"userNewOrderBasic","userNewPhotoGiftOrderFinalize":"userNewPhotoGiftOrderFinalize","settingsOther":"settingsOther","stats":"stats","userCashier":"userCashier","userSettings":"userSettings","login":"login","privacyPolicy":"privacyPolicy","settingsPhotoGiftBasic":"settingsPhotoGiftBasic","settingsPhotoOrderBasic":"settingsPhotoOrderBasic","settingsSubMenu":"settingsSubMenu","settingsSubMenuImageDatabase":"settingsSubMenuImageDatabase","settingsSubMenuModuleGiftCard":"settingsSubMenuModuleGiftCard","settingsSubMenuModulePhotoGift":"settingsSubMenuModulePhotoGift","settingsSubMenuModulePhotoOrder":"settingsSubMenuModulePhotoOrder","settingsSubMenuModuleUserSettings":"settingsSubMenuModuleUserSettings","settingsUserRights":"settingsUserRights","settingsUserSettingsBasic":"settingsUserSettingsBasic","userCart":"userCart","userGiftPrices":"userGiftPrices","userImagePrices":"userImagePrices","userNewPhotoGiftOrder":"userNewPhotoGiftOrder"}[chunkId]||chunkId) + "." + {"fbDataDeletionInstructions":"0ac6c7ef","homeMenuAdminArchive~homeMenuAdminPackages~userOrders":"810b7793","homeMenuAdminPackages":"2dc29a56","homeMenuAdminArchive~settingsClient~settingsColors~settingsDelivery~settingsGiftCardActive~settingsI~16d883cc":"e4169494","homeMenuAdminArchive":"5e4dedc8","userOrders":"73299d2d","settingsClient~settingsDelivery~settingsGiftCardActive~settingsImageDatabase~settingsImageDatabaseCa~9ab29113":"d6260f07","settingsClient":"6a7d9624","settingsDelivery":"34d798ad","settingsGiftCardActive~settingsPromoCodes":"43813753","settingsGiftCardActive":"6b00f577","settingsPromoCodes":"82a0a416","settingsImageDatabaseCategory":"f3af3029","settingsImageDatabase~settingsImageTemplate~settingsPhotoGift~userNewOrderBasic~userNewPhotoGiftOrde~6de9c91a":"58e1d16d","settingsImageDatabase~settingsImageTemplate~settingsPhotoGift~userNewOrderBasic~userNewPhotoGiftOrderDesign":"3347f263","settingsImageDatabase":"2dbd8022","settingsImageTemplate":"11c1583b","settingsPhotoGift":"59744872","settingsImageDiscounts":"218191c9","settingsImageSize":"30971a0c","settingsPaperType":"68d03e7a","settingsPhotoGiftCategory":"fe6612e8","settingsPhotoGiftSuperCategory":"b6d43b92","settingsColors~userNewPhotoGiftOrderDesign":"b071ed25","settingsColors":"f4f8d52f","userNewPhotoGiftOrderDesign":"32ef1e3d","userNewOrderBasic~userNewPhotoGiftOrderFinalize":"3fb53642","userNewOrderBasic":"9f721ab2","userNewPhotoGiftOrderFinalize":"9fbeeba7","settingsOther":"041f880c","stats":"fe1b609e","userCashier":"cf6b7937","userSettings":"859bfea5","login":"ac5bfcd1","privacyPolicy":"260027ff","settingsPhotoGiftBasic":"c41fdb47","settingsPhotoOrderBasic":"eaba3420","settingsSubMenu":"649224d2","settingsSubMenuImageDatabase":"ec1b7f6f","settingsSubMenuModuleGiftCard":"a79aa5c8","settingsSubMenuModulePhotoGift":"ba3a5c52","settingsSubMenuModulePhotoOrder":"02e10834","settingsSubMenuModuleUserSettings":"5351d53d","settingsUserRights":"c19a21f3","settingsUserSettingsBasic":"acc6e04f","userCart":"4e54619c","userGiftPrices":"bec792f5","userImagePrices":"842d142e","userNewPhotoGiftOrder":"430e479f"}[chunkId] + ".1.8.1.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"homeMenuAdminPackages":1,"homeMenuAdminArchive~settingsClient~settingsColors~settingsDelivery~settingsGiftCardActive~settingsI~16d883cc":1,"homeMenuAdminArchive":1,"userOrders":1,"settingsClient~settingsDelivery~settingsGiftCardActive~settingsImageDatabase~settingsImageDatabaseCa~9ab29113":1,"settingsClient":1,"settingsDelivery":1,"settingsGiftCardActive~settingsPromoCodes":1,"settingsImageDatabaseCategory":1,"settingsImageDatabase~settingsImageTemplate~settingsPhotoGift~userNewOrderBasic~userNewPhotoGiftOrderDesign":1,"settingsImageDatabase":1,"settingsImageTemplate":1,"settingsPhotoGift":1,"settingsImageSize":1,"settingsPaperType":1,"settingsPhotoGiftCategory":1,"settingsPhotoGiftSuperCategory":1,"settingsColors~userNewPhotoGiftOrderDesign":1,"userNewPhotoGiftOrderDesign":1,"userNewOrderBasic":1,"settingsOther":1,"userSettings":1,"login":1,"settingsPhotoOrderBasic":1,"settingsSubMenu":1,"settingsSubMenuImageDatabase":1,"settingsSubMenuModuleGiftCard":1,"settingsSubMenuModulePhotoGift":1,"settingsSubMenuModulePhotoOrder":1,"settingsSubMenuModuleUserSettings":1,"settingsUserRights":1,"settingsUserSettingsBasic":1,"userCart":1,"userGiftPrices":1,"userImagePrices":1,"userNewPhotoGiftOrder":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"fbDataDeletionInstructions":"fbDataDeletionInstructions","homeMenuAdminArchive~homeMenuAdminPackages~userOrders":"homeMenuAdminArchive~homeMenuAdminPackages~userOrders","homeMenuAdminPackages":"homeMenuAdminPackages","homeMenuAdminArchive~settingsClient~settingsColors~settingsDelivery~settingsGiftCardActive~settingsI~16d883cc":"homeMenuAdminArchive~settingsClient~settingsColors~settingsDelivery~settingsGiftCardActive~settingsI~16d883cc","homeMenuAdminArchive":"homeMenuAdminArchive","userOrders":"userOrders","settingsClient~settingsDelivery~settingsGiftCardActive~settingsImageDatabase~settingsImageDatabaseCa~9ab29113":"settingsClient~settingsDelivery~settingsGiftCardActive~settingsImageDatabase~settingsImageDatabaseCa~9ab29113","settingsClient":"settingsClient","settingsDelivery":"settingsDelivery","settingsGiftCardActive~settingsPromoCodes":"settingsGiftCardActive~settingsPromoCodes","settingsGiftCardActive":"settingsGiftCardActive","settingsPromoCodes":"settingsPromoCodes","settingsImageDatabaseCategory":"settingsImageDatabaseCategory","settingsImageDatabase~settingsImageTemplate~settingsPhotoGift~userNewOrderBasic~userNewPhotoGiftOrde~6de9c91a":"settingsImageDatabase~settingsImageTemplate~settingsPhotoGift~userNewOrderBasic~userNewPhotoGiftOrde~6de9c91a","settingsImageDatabase~settingsImageTemplate~settingsPhotoGift~userNewOrderBasic~userNewPhotoGiftOrderDesign":"settingsImageDatabase~settingsImageTemplate~settingsPhotoGift~userNewOrderBasic~userNewPhotoGiftOrderDesign","settingsImageDatabase":"settingsImageDatabase","settingsImageTemplate":"settingsImageTemplate","settingsPhotoGift":"settingsPhotoGift","settingsImageDiscounts":"settingsImageDiscounts","settingsImageSize":"settingsImageSize","settingsPaperType":"settingsPaperType","settingsPhotoGiftCategory":"settingsPhotoGiftCategory","settingsPhotoGiftSuperCategory":"settingsPhotoGiftSuperCategory","settingsColors~userNewPhotoGiftOrderDesign":"settingsColors~userNewPhotoGiftOrderDesign","settingsColors":"settingsColors","userNewPhotoGiftOrderDesign":"userNewPhotoGiftOrderDesign","userNewOrderBasic~userNewPhotoGiftOrderFinalize":"userNewOrderBasic~userNewPhotoGiftOrderFinalize","userNewOrderBasic":"userNewOrderBasic","userNewPhotoGiftOrderFinalize":"userNewPhotoGiftOrderFinalize","settingsOther":"settingsOther","stats":"stats","userCashier":"userCashier","userSettings":"userSettings","login":"login","privacyPolicy":"privacyPolicy","settingsPhotoGiftBasic":"settingsPhotoGiftBasic","settingsPhotoOrderBasic":"settingsPhotoOrderBasic","settingsSubMenu":"settingsSubMenu","settingsSubMenuImageDatabase":"settingsSubMenuImageDatabase","settingsSubMenuModuleGiftCard":"settingsSubMenuModuleGiftCard","settingsSubMenuModulePhotoGift":"settingsSubMenuModulePhotoGift","settingsSubMenuModulePhotoOrder":"settingsSubMenuModulePhotoOrder","settingsSubMenuModuleUserSettings":"settingsSubMenuModuleUserSettings","settingsUserRights":"settingsUserRights","settingsUserSettingsBasic":"settingsUserSettingsBasic","userCart":"userCart","userGiftPrices":"userGiftPrices","userImagePrices":"userImagePrices","userNewPhotoGiftOrder":"userNewPhotoGiftOrder"}[chunkId]||chunkId) + "." + {"fbDataDeletionInstructions":"31d6cfe0","homeMenuAdminArchive~homeMenuAdminPackages~userOrders":"31d6cfe0","homeMenuAdminPackages":"afd7d987","homeMenuAdminArchive~settingsClient~settingsColors~settingsDelivery~settingsGiftCardActive~settingsI~16d883cc":"d37f8add","homeMenuAdminArchive":"ce5588c7","userOrders":"3a934129","settingsClient~settingsDelivery~settingsGiftCardActive~settingsImageDatabase~settingsImageDatabaseCa~9ab29113":"c423b9b4","settingsClient":"559607c5","settingsDelivery":"559607c5","settingsGiftCardActive~settingsPromoCodes":"9292991d","settingsGiftCardActive":"31d6cfe0","settingsPromoCodes":"31d6cfe0","settingsImageDatabaseCategory":"559607c5","settingsImageDatabase~settingsImageTemplate~settingsPhotoGift~userNewOrderBasic~userNewPhotoGiftOrde~6de9c91a":"31d6cfe0","settingsImageDatabase~settingsImageTemplate~settingsPhotoGift~userNewOrderBasic~userNewPhotoGiftOrderDesign":"4b105d19","settingsImageDatabase":"559607c5","settingsImageTemplate":"b054696c","settingsPhotoGift":"559607c5","settingsImageDiscounts":"31d6cfe0","settingsImageSize":"559607c5","settingsPaperType":"559607c5","settingsPhotoGiftCategory":"3a63477c","settingsPhotoGiftSuperCategory":"3a63477c","settingsColors~userNewPhotoGiftOrderDesign":"bb4118a0","settingsColors":"31d6cfe0","userNewPhotoGiftOrderDesign":"922870b0","userNewOrderBasic~userNewPhotoGiftOrderFinalize":"31d6cfe0","userNewOrderBasic":"7b13cb8e","userNewPhotoGiftOrderFinalize":"31d6cfe0","settingsOther":"5db1cada","stats":"31d6cfe0","userCashier":"31d6cfe0","userSettings":"559607c5","login":"f397adb8","privacyPolicy":"31d6cfe0","settingsPhotoGiftBasic":"31d6cfe0","settingsPhotoOrderBasic":"888037c3","settingsSubMenu":"2738743c","settingsSubMenuImageDatabase":"cc9a404f","settingsSubMenuModuleGiftCard":"162d27d5","settingsSubMenuModulePhotoGift":"46766a78","settingsSubMenuModulePhotoOrder":"3d4985c6","settingsSubMenuModuleUserSettings":"a397e5f1","settingsUserRights":"559607c5","settingsUserSettingsBasic":"888037c3","userCart":"c7315fda","userGiftPrices":"d4808dec","userImagePrices":"d4808dec","userNewPhotoGiftOrder":"c3d92e09"}[chunkId] + ".1.8.1.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
